import { ConfigRecord } from "./ConfigRecord";
import * as GlobalTypes from "../../types";
import { DesiredStateItem } from "./DesiredState";
import * as uuid from 'uuid';

export type ThemesRecord = ConfigRecord<ThemesConfig>;
export type ThemesConfig = ThemeItem[];

export class ThemeItem {
    UUID: GlobalTypes.UUIDV4;
    Icon: GlobalTypes.IconDefinition;
    isWorking: boolean;
    DesiredStates: DesiredStateItem[];
}